import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Avatar, AvatarGroup, HStack, IconButton, Text } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { ChatThread } from '@src/components/sco/Chat/ChatThread';
import { useMatchingContext } from '@src/components/sco/Matching/Layout/MatchingContext';
import { ScoThread } from '@src/graphql-types';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { gql } from '@src/lib/gql';
import { LuChevronLeft, LuX } from 'react-icons/lu';
export const UserMatchChatThread = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props.threadId) {
    t0 = <ChatThread renderCustomHeader={_temp} threadId={props.threadId} />;
    $[0] = props.threadId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const UserMatchChatThreadHeader = props => {
  const $ = _c(69);
  const layout = useParentAppLayout();
  const matchingContext = useMatchingContext();
  const {
    currentUser
  } = useCurrentUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($threadId: String!) {
        forum {
          id
          thread(threadId: $threadId) {
            id
            title
            threadId
            threadTypeKey
            userMemberships {
              id
              items {
                id
                user {
                  id
                  userId
                  fullName
                  pictureUrl
                }
              }
            }
          }
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.threadId) {
    t1 = {
      variables: {
        threadId: props.threadId
      }
    };
    $[1] = props.threadId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = useQuery(t0, t1);
  const thread = query.data?.forum.thread;
  let T0;
  let T1;
  let T2;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== currentUser || $[4] !== matchingContext || $[5] !== query.error || $[6] !== thread) {
    const recipientUsers = thread ? thread.userMemberships.items.filter(membership => thread.userMemberships.items.length === 1 || membership.user.userId !== currentUser.userId).map(_temp2) : [];
    T2 = HStack;
    t7 = "center";
    t8 = "blur(10px)";
    t9 = "backgroundAlpha.900";
    t10 = "1px solid";
    t11 = "blackAlpha.500";
    t12 = "md";
    t13 = "3.5em";
    t14 = "flex-start";
    t15 = "1em";
    t16 = 1;
    if ($[28] !== query.error) {
      t17 = query.error && <Text>{"Error: "}{query.error.toString()}</Text>;
      $[28] = query.error;
      $[29] = t17;
    } else {
      t17 = $[29];
    }
    if ($[30] !== thread) {
      t18 = !thread && <Text>Loading...</Text>;
      $[30] = thread;
      $[31] = t18;
    } else {
      t18 = $[31];
    }
    let t20;
    if ($[32] !== matchingContext) {
      t20 = () => {
        matchingContext.setChatThreadId(null);
      };
      $[32] = matchingContext;
      $[33] = t20;
    } else {
      t20 = $[33];
    }
    let t21;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <LuChevronLeft />;
      $[34] = t21;
    } else {
      t21 = $[34];
    }
    if ($[35] !== t20) {
      t19 = <IconButton aria-label="Back to Messages" borderRadius="md" size="sm" variant="outline" onClick={t20}>{t21}</IconButton>;
      $[35] = t20;
      $[36] = t19;
    } else {
      t19 = $[36];
    }
    T1 = HStack;
    t4 = "center";
    t5 = "full";
    t6 = <AvatarGroup>{recipientUsers.map(_temp3)}</AvatarGroup>;
    T0 = Text;
    t2 = "bold";
    t3 = recipientUsers.map(_temp4).join(", ");
    $[3] = currentUser;
    $[4] = matchingContext;
    $[5] = query.error;
    $[6] = thread;
    $[7] = T0;
    $[8] = T1;
    $[9] = T2;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
    $[17] = t17;
    $[18] = t18;
    $[19] = t19;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    T0 = $[7];
    T1 = $[8];
    T2 = $[9];
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
    t17 = $[17];
    t18 = $[18];
    t19 = $[19];
    t2 = $[20];
    t3 = $[21];
    t4 = $[22];
    t5 = $[23];
    t6 = $[24];
    t7 = $[25];
    t8 = $[26];
    t9 = $[27];
  }
  let t20;
  if ($[37] !== T0 || $[38] !== t2 || $[39] !== t3) {
    t20 = <T0 fontWeight={t2}>{t3}</T0>;
    $[37] = T0;
    $[38] = t2;
    $[39] = t3;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== T1 || $[42] !== t20 || $[43] !== t4 || $[44] !== t5 || $[45] !== t6) {
    t21 = <T1 justify={t4} width={t5}>{t6}{t20}</T1>;
    $[41] = T1;
    $[42] = t20;
    $[43] = t4;
    $[44] = t5;
    $[45] = t6;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== layout) {
    t22 = () => {
      layout.toggle("matching-aside");
    };
    $[47] = layout;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <LuX />;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t22) {
    t24 = <IconButton aria-label="Close Messages" borderRadius="md" size="sm" variant="outline" onClick={t22}>{t23}</IconButton>;
    $[50] = t22;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== T2 || $[53] !== t10 || $[54] !== t11 || $[55] !== t12 || $[56] !== t13 || $[57] !== t14 || $[58] !== t15 || $[59] !== t16 || $[60] !== t17 || $[61] !== t18 || $[62] !== t19 || $[63] !== t21 || $[64] !== t24 || $[65] !== t7 || $[66] !== t8 || $[67] !== t9) {
    t25 = <T2 align={t7} backdropFilter={t8} bgColor={t9} borderBottom={t10} borderBottomColor={t11} boxShadow={t12} height={t13} justify={t14} padding={t15} zIndex={t16}>{t17}{t18}{t19}{t21}{t24}</T2>;
    $[52] = T2;
    $[53] = t10;
    $[54] = t11;
    $[55] = t12;
    $[56] = t13;
    $[57] = t14;
    $[58] = t15;
    $[59] = t16;
    $[60] = t17;
    $[61] = t18;
    $[62] = t19;
    $[63] = t21;
    $[64] = t24;
    $[65] = t7;
    $[66] = t8;
    $[67] = t9;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  return t25;
};
function _temp(headerThreadId) {
  return <UserMatchChatThreadHeader threadId={headerThreadId} />;
}
function _temp2(membership_0) {
  return membership_0.user;
}
function _temp3(user) {
  return <Avatar.Root key={user.userId} border="none" size="xs"><Avatar.Fallback /><Avatar.Image src={user.pictureUrl} /></Avatar.Root>;
}
function _temp4(user_0) {
  return user_0.fullName;
}